import React, { useEffect, useState } from "react";
import styles from "./listItem.module.scss";

interface ListItemProps {
    data: any;
    item?: any;
    children?: any;
    onClick?: (data: any) => void;
}

export const ListItem: React.FC<ListItemProps> = ({
    data,
    item,
    children,
    onClick,
}) => {
    return data.map((e, i) => (
        <div key={e} onClick={() => onClick(e)} className={styles.item}>
            {e}
        </div>
    ));
};
